// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown__38PBB","show-share-button":"show-share-button__REMNN","icon":"icon__WCupJ","link":"link__tvurE","name":"name__hrLkR","project-status":"project-status__EsmDy"};